// assets/vh-h2.js — WP-P21 Startseite V2: zusammengesetzt aus den Fragmenten der Teile A/B/C (Hauptmodell, 23.09.2026).
// Geladen aus sections/vh-h2-hero.liquid NACH vh-v2.js, vh-c2.js und vh-h.js. ES5, keine Timer-Schleifen, kein MutationObserver.

// ===== WP-P22b =====
// WP-P22b — Teil A: gesamter Inhalt von assets/vh-h2.js (Hero-Video-Quellwahl, Play/Pause-Knopf,
// prefers-reduced-motion/Datensparmodus). ES5, eine IIFE, kein Framework, keine Timer-Schleifen, kein
// MutationObserver. Wird vom Hauptmodell aus sections/vh-h2-hero.liquid geladen (Brief §1 Ladestelle:
// vh-v2.js -> vh-c2.js -> vh-h.js -> vh-h2.js).
//
// Doppelbindung vermieden (WP-P21 §2.1): das Hero-<video> trägt NICHT die Klasse vh-h-video und KEIN
// data-vh-video-toggle -- die bestehende Herkunft-Logik in assets/vh-h.js (WP-P20c) bindet deshalb
// nicht zusätzlich an dieses Element. Eigene Attribute: data-vh-h2-video, data-vh-h2-toggle.
(function () {
  'use strict';

  var video = document.querySelector('[data-vh-h2-video]');
  if (!video) { return; }

  var reduceMotion = false;
  try { reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var saveData = false;
  try { saveData = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}

  // ---------- Quellwahl: einmalig beim Laden, kein Neuladen bei Resize (WP-P21 §2.1) ----------
  // < 700px -> Hochformat-Quelle, >= 700px -> breite Quelle. Kein <source>-Kind im Markup, damit vor
  // dem JS-Lauf nur das Poster (Fallback ohne JS) sichtbar ist -- das Poster ist das LCP-Element.
  var isPortrait = false;
  try { isPortrait = window.matchMedia && window.matchMedia('(max-width: 699px)').matches; } catch (e) {}

  // Quellen erst nach window.load anhaengen: das Poster bleibt LCP-Element, der Videodownload
  // konkurriert nicht mit Poster/CSS/Schrift (Hauptmodell r3: PSI mobil LCP 8,6 s vor dieser Aenderung).
  // Poster sofort (vor window.load) passend zur Ausrichtung setzen — kein Bildwechsel nach dem Laden.
  var poster = isPortrait ? video.getAttribute('data-poster-portrait') : video.getAttribute('data-poster-wide');
  if (poster) { video.setAttribute('poster', poster); }

  function attachSources() {
    var mp4 = isPortrait ? video.getAttribute('data-src-portrait-mp4') : video.getAttribute('data-src-wide-mp4');
    var webm = isPortrait ? video.getAttribute('data-src-portrait-webm') : video.getAttribute('data-src-wide-webm');
    // ---------- prefers-reduced-motion / Datensparmodus: gar nichts laden, Poster bleibt sichtbar ----------
    // Reihenfolge bewusst vor der Quellwahl (Befund WP-P22-Review): vorher hingen <source>-Kinder und
    // video.load() immer vor dieser Pruefung, wodurch der Browser Metadaten/den Video-Header auch bei
    // reduzierter Bewegung oder Datensparmodus lud. Jetzt: bei true weder <source> anhaengen noch laden.
    if (reduceMotion || saveData) {
      video.removeAttribute('autoplay');
      video.pause();
    } else {
      if (webm) {
        var sourceWebm = document.createElement('source');
        sourceWebm.setAttribute('src', webm);
        sourceWebm.setAttribute('type', 'video/webm');
        video.appendChild(sourceWebm);
      }
      if (mp4) {
        var sourceMp4 = document.createElement('source');
        sourceMp4.setAttribute('src', mp4);
        sourceMp4.setAttribute('type', 'video/mp4');
        video.appendChild(sourceMp4);
      }
      if (webm || mp4) { video.load(); }
    }
  }
  if (document.readyState === 'complete') { attachSources(); }
  else { window.addEventListener('load', attachSources); }

  // Kein Pause-Knopf mehr (Inhaber 30.09.2026): das Video läuft nur noch als Endlos-Loop,
  // gesteuert allein über autoplay/loop-Attribut und die reduceMotion/saveData-Prüfung oben.
})();

// ===== WP-P22c =====
// WP-P22c — Teil B (h2-auswahl, h2-tag, h2-jahre, h2-loox) der Startseite V2 "Story".
// Brief: neustart-2026/arbeitspakete/WP-P22-startseite-v2-story.md.
// Eine IIFE, ES5, kein Framework, kein MutationObserver, keine Timer-Schleifen.
// Wird vom Hauptmodell hinter WP-P22b-js.js in assets/vh-h2.js eingefügt (Reihenfolge A -> B -> C).
//
// Eigener Attribut-Namensraum data-vh2-count-* (statt data-count-*): assets/vh-h.js ist laut
// Ladestelle (WP-P21 Sec2.1, weiter gueltig laut WP-P22 Kopf) VOR vh-h2.js geladen und beobachtet
// bereits generisch jedes [data-count-to] im Dokument (Count-up aus WP-P20c). Wuerde dieses
// Fragment dieselben Attribute erneut ueber einen zweiten IntersectionObserver beobachten,
// schrieben zwei Observer gleichzeitig denselben textContent (Race Condition/Flackern). Die
// Loox-Zahlen in h2-jahre bekommen deshalb data-vh2-count-to/-decimals - ein eigener Namensraum,
// den nur dieses Fragment beobachtet, keine Kollision moeglich, funktioniert unabhaengig davon,
// ob assets/vh-h.js in der jeweiligen Zusammenstellung ueberhaupt geladen ist.
(function () {
  'use strict';

  var html = document.documentElement;
  var $$ = function (selector, ctx) {
    return [].slice.call((ctx || document).querySelectorAll(selector));
  };

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* matchMedia in seltenen alten Browsern nicht verfuegbar - Default false */ }

  // ---------- Count-up (h2-jahre: Loox-Zeile, Bewertung + Anzahl) ----------
  // Gated: nur wenn html.vh-h-js bereits gesetzt ist (Brief-Vorgabe "gated html.vh-h-js" - die
  // Klasse setzt assets/vh-h.js sofort beim Laden, s. WP-P20d) UND ohne reduzierte Bewegung.
  // Ohne diese beiden Bedingungen bleibt der von Liquid gerenderte Endwert stehen (korrekt).
  function initCountUp() {
    if (reduceMotion || typeof window.IntersectionObserver !== 'function') { return; }
    if (!html.classList.contains('vh-h-js')) { return; }

    $$('[data-vh2-count-to]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-vh2-count-to'));
      if (isNaN(target)) { return; }
      var decimals = parseInt(el.getAttribute('data-vh2-count-decimals'), 10) || 0;
      var endText = el.textContent;
      var done = false;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !done) {
            done = true;
            io.unobserve(el);
            var duration = 900;
            var t0 = null;
            function frame(ts) {
              if (t0 === null) { t0 = ts; }
              var p = Math.min(1, (ts - t0) / duration);
              var val = target * p;
              var text;
              try {
                text = val.toLocaleString('de-DE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
              } catch (e2) {
                text = val.toFixed(decimals);
              }
              el.textContent = (p < 1) ? text : endText;
              if (p < 1) { window.requestAnimationFrame(frame); }
            }
            window.requestAnimationFrame(frame);
          }
        });
      }, { threshold: 0.3 });
      io.observe(el);
    });
  }

  // ---------- Loox-Deckel (h2-loox): Button entfernt is-capped einmalig, kein Timer ----------
  function initLooxCap() {
    $$('[data-vh2-loox-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('.vh-h2-loox');
        var cap = section ? section.querySelector('[data-vh2-loox-cap]') : null;
        if (cap) { cap.classList.remove('is-capped'); }
        btn.setAttribute('aria-expanded', 'true');
        // Der Button hat nach dem Entfernen des Deckels keine Funktion mehr - Ausblenden statt
        // ihn wirkungslos unter dem voll aufgeklappten Widget stehen zu lassen (Abweichung von der
        // reinen Wortvorgabe, dokumentiert im Protokoll, aendert keinen sichtbaren Text).
        btn.setAttribute('hidden', 'hidden');
      });
    });
  }

  function init() {
    initCountUp();
    initLooxCap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ===== WP-P22d =====
// WP-P22d — Teil C (Startseite V2 „Story"): Gründer, Herkunft, Wissen, Magazin, Schluss.
// Wird vom Hauptmodell hinter die Fragmente WP-P22b/WP-P22c in assets/vh-h2.js eingefügt
// (Reihenfolge A -> B -> C, Brief §1).
//
// Absichtlich leer (Brief erlaubt das ausdrücklich: "Fragmente _out/WP-P22d-js.js (leer erlaubt)").
// Begründung: keine der fünf Teil-C-Sektionen braucht eigenes Verhalten.
// - vh-h2-gruender / vh-h2-wissen / vh-h2-magazin / vh-h2-schluss: reines Markup, kein Skript nötig.
// - vh-h2-herkunft: das Loop-Video trägt dieselben Hooks wie r2 (Klassen vh-h-video /
//   vh-h-herkunft__media, Knopf [data-vh-video-toggle]) — das bereits vor vh-h2.js geladene
//   assets/vh-h.js (WP-P20c) verdrahtet Play/Pause und den einmaligen Autostart beim
//   Sichtbarwerden für JEDES Element mit der Klasse .vh-h-video, unabhängig davon, in welcher
//   Sektion es steht. Ein zweiter Handler hier würde doppelt binden (Falle "Doppelbindung", s.
//   WP-P22-Brief §1 Zeile h2-hero).
// - Reveal ([data-vh-reveal] -> .is-in unter html.vh-h-js) läuft ebenfalls schon global aus
//   assets/vh-h.js (WP-P20d); alle Teil-C-Sektionen tragen data-vh-reveal und werden davon erfasst.
(function () { 'use strict'; })();

// ===== r8 sticky =====
// WP-P25 (N-H15): mobile Sticky-CTA-Leiste. ES5, rAF-gedrosselter Scroll-Listener, kein Timer, kein MutationObserver.
// Sichtbar nur < 900px, sobald der Hero komplett ueber dem Viewport liegt; versteckt, sobald Newsletter oder Footer im Viewport sind.
(function () {
  'use strict';
  var bar = document.querySelector('[data-vh2-sticky]');
  if (!bar) { return; }
  var hero = document.querySelector('.vh-h2-hero');
  var ends = [].slice.call(document.querySelectorAll('[id^="shopify-section-"][id$="h2-newsletter"], footer, .footer'));
  var mq = null;
  try { mq = window.matchMedia && window.matchMedia('(max-width: 899px)'); } catch (e) {}
  var ticking = false, shown = false;
  function setShown(on) {
    if (on === shown) { return; }
    shown = on;
    if (on) { bar.removeAttribute('hidden'); bar.setAttribute('aria-hidden', 'false'); bar.className = bar.className.replace(/\s*is-off/g, '') + ' is-on'; }
    else { bar.className = bar.className.replace(/\s*is-on/g, ''); bar.setAttribute('aria-hidden', 'true'); bar.setAttribute('hidden', 'hidden'); }
  }
  function check() {
    ticking = false;
    if (mq && !mq.matches) { setShown(false); return; }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var past = hero ? hero.getBoundingClientRect().bottom <= 0 : (window.pageYOffset > 700);
    var nearEnd = false;
    for (var i = 0; i < ends.length; i++) { var r = ends[i].getBoundingClientRect(); if (r.top < vh && r.bottom > 0) { nearEnd = true; break; } }
    setShown(past && !nearEnd);
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  check();
})();

